import { request } from '../../request';
import { SingleShift } from '@libs/models/shifts/shift';

export type SingleShiftCreateData = Omit<SingleShift, 'startDate'> & {
  startDate: string;
  specialty?: string;
  unassignReason?: string;
  doubleShiftOptions?: {
    isDoubleShift: boolean;
    overlappedShiftId: string;
  };
};
export async function createSingleShift(data: SingleShiftCreateData): Promise<string[]> {
  const response = await request.post<string[]>('/v2/shifts/single', {
    ...data,
    specialityId: data.specialtyId || null,
    subDepartmentNodeId: data.subDepartmentNodeId || null,
    startDate: { dateTime: data.startDate, timezone: data.timeZone },
    doubleShiftOptions: data.doubleShiftOptions
      ? {
          isDoubleShift: data.doubleShiftOptions.isDoubleShift,
          overlappedShiftId: data.doubleShiftOptions.overlappedShiftId,
        }
      : {
          isDoubleShift: false,
          overlappedShiftId: null,
        },
  });
  return response.data;
}
